import { useMemo } from 'react';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';

const useStaticExamplesEnabled = () => {
  return useMemo(() => Auth.isFeatureEnabled(FEATURES.enableStaticQuickSearchExamples), []);
};

export default useStaticExamplesEnabled;
